export default __webpack_public_path__ + "static/media/evo-icon.d4851233.webp";